// import React, { useRef, useState, useEffect } from "react";
// import Editor from "@monaco-editor/react";

// function JsCompiler() {
//   const [code, setCode] = useState(`// Codeforces Problem A: Team
// const fs = require('fs');
// const data = fs.readFileSync(0, 'utf8').trim().split('\\n');

// const n = parseInt(data[0]);
// let count = 0;

// for (let i = 1; i <= n; i++) {
//   const nums = data[i].split(' ').map(Number);
//   const sure = nums.reduce((a, b) => a + b, 0);
//   if (sure >= 2) count++;
// }

// console.log(count);

// `);
//   const [userInput, setUserInput] = useState("3\n1 1 0\n1 1 1\n1 0 0");
//   const [expectedOutput, setExpectedOutput] = useState("2");
//   const [output, setOutput] = useState("");
//   const [status, setStatus] = useState("Ready");
//   const [verdict, setVerdict] = useState(null);
//   const [showLoader, setShowLoader] = useState(true);

//   const iframeRef = useRef(null);
//   const handlerRef = useRef(null);
//   const outputRef = useRef(null);

//   useEffect(() => {
//     const timer = setTimeout(() => setShowLoader(false), 600);
//     return () => clearTimeout(timer);
//   }, []);

//   // Utility to append output + auto-scroll
//   const appendOutput = (text) => {
//     setOutput((prev) => {
//       const next = prev + text;
//       setTimeout(() => {
//         if (outputRef.current) outputRef.current.scrollTop = outputRef.current.scrollHeight;
//       }, 0);
//       return next;
//     });
//   };

//   // Transform some common Node fs usage into __readStdin() calls and shim require('fs')
//   function transformNodeStyleCode(userCode) {
//     let transformed = userCode;

//     // Replace require('fs') declarations with a shim object
//     transformed = transformed.replace(
//       /\b(?:const|let|var)\s+([A-Za-z_$][\w$]*)\s*=\s*require\(\s*['"]fs['"]\s*\)\s*;?/g,
//       (m, varName) => {
//         return `const ${varName} = { readFileSync: ()=>__readStdin() };`;
//       }
//     );

//     // Replace inline require('fs').readFileSync(0,'utf8') usages
//     transformed = transformed.replace(
//       /require\(\s*['"]fs['"]\s*\)\s*\.readFileSync\s*\(\s*0\s*(?:,\s*['"]utf-?8['"]\s*)?\)/g,
//       "__readStdin()"
//     );

//     // Replace fs.readFileSync(0, 'utf8') occurrences
//     transformed = transformed.replace(
//       /\b([A-Za-z_$][\w$]*)\.readFileSync\s*\(\s*0\s*(?:,\s*['"]utf-?8['"]\s*)?\)/g,
//       "__readStdin()"
//     );

//     // Replace bare require('fs') usages with shim object
//     transformed = transformed.replace(/require\(\s*['"]fs['"]\s*\)/g, "{ readFileSync: ()=>__readStdin() }");

//     // If users used process.stdin streaming style, we provide a simple shim in the iframe; no transform needed.
//     return transformed;
//   }

//   const runJs = () => {
//     setStatus("Running JavaScript...");
//     setOutput("");
//     setVerdict(null);

//     // Cleanup prior iframe & handler
//     if (iframeRef.current) {
//       try { document.body.removeChild(iframeRef.current); } catch (e) {}
//       iframeRef.current = null;
//     }
//     if (handlerRef.current) {
//       window.removeEventListener("message", handlerRef.current);
//       handlerRef.current = null;
//     }

//     const inputs = userInput.replace(/\r/g, "").split("\n");
//     const transformedCode = transformNodeStyleCode(code);

//     // Iframe HTML with helpers:
//     // - forwards console.log/error to parent
//     // - defines __readStdin() and input(prompt)
//     // - provides a basic process.stdin shim that triggers data/end handlers
//     // - posts a 'done' message when execution finishes (so parent can run verdict)
//     const iframeHtml = `<!doctype html>
// <html><head><meta charset="utf-8"></head><body>
// <script>
// (function(){
//   function forward(type, text) {
//     parent.postMessage({ type: type, data: String(text) }, "*");
//   }

//   // minimal console wrapper
//   window.console = {
//     log: (...args) => forward('log', args.join(' ')),
//     error: (...args) => forward('error', args.join(' ')),
//     warn: (...args) => forward('log', args.join(' '))
//   };

//   let __inputs = [];
//   let __idx = 0;

//   function __readStdin() {
//     return __inputs.join('\\n');
//   }

//   function input(promptText) {
//     const hasPrompt = (typeof promptText === 'string' && promptText.length > 0);
//     if (hasPrompt) console.log(promptText);
//     const val = (__idx < __inputs.length) ? __inputs[__idx++] : undefined;
//     if (hasPrompt) console.log((val === undefined) ? "[No Input Provided]" : String(val));
//     if (val === undefined) throw new Error('No more input provided!');
//     return val;
//   }

//   // simple process.stdin shim to support code using process.stdin.on('data', ...)
//   const process = {
//     stdin: {
//       on: function(evt, cb) {
//         try {
//           if (evt === 'data') cb(__readStdin());
//           if (evt === 'end') cb();
//         } catch (e) { /* ignore */ }
//       },
//       setEncoding: function() {}
//     }
//   };

//   window.__readStdin = __readStdin;
//   window.input = input;
//   window.process = process;

//   window.addEventListener('message', function(ev) {
//     try {
//       const payload = ev.data || {};
//       if (!payload.code) return;
//       __inputs = Array.isArray(payload.inputs) ? payload.inputs.slice() : [];
//       __idx = 0;

//       try {
//         (function(){
//           eval(payload.code);
//         })();
//       } catch (execErr) {
//         console.error(execErr && execErr.message ? execErr.message : String(execErr));
//       } finally {
//         // notify parent that execution finished (gives parent chance to compute verdict)
//         parent.postMessage({ type: 'done' }, "*");
//       }
//     } catch (outer) {
//       console.error(outer && outer.message ? outer.message : String(outer));
//       parent.postMessage({ type: 'done' }, "*");
//     }
//   });
// })();
// <\/script>
// </body></html>`;

//     const iframe = document.createElement("iframe");
//     iframe.sandbox = "allow-scripts";
//     iframe.style.display = "none";
//     iframe.srcdoc = iframeHtml;
//     document.body.appendChild(iframe);
//     iframeRef.current = iframe;

//     // message handler
// // message handler
// const handleMessage = (event) => {
//   const d = event.data || {};
//   if (d.type === "log") {
//     appendOutput(d.data + "\n");
//   } else if (d.type === "error") {
//     appendOutput("Error: " + d.data + "\n");
//   } else if (d.type === "done") {
//     // Execution finished — compare with expectedOutput if provided
//     setStatus("Execution finished");

//     if (expectedOutput && expectedOutput.trim().length > 0) {
//       // wait a tick so appendOutput/setOutput flush to DOM
//       setTimeout(() => {
//         // read actual output from DOM textarea to avoid stale-closure problems
//         const actualRaw = outputRef.current ? outputRef.current.value : output;
//         const expectedRaw = expectedOutput;

//         // normalize both sides: remove CRs, trim trailing spaces per line, remove trailing blank lines
//         const normalize = (s) =>
//           (s ?? "")
//             .replace(/\r/g, "")
//             .split("\n")
//             .map(line => line.replace(/[ \t]+$/g, "")) // trim trailing spaces/tabs
//             .join("\n")
//             .replace(/\n+$/g, "") // remove trailing blank lines
//             .trim();

//         const actual = normalize(actualRaw);
//         const expected = normalize(expectedRaw);

//         if (actual === expected) {
//           setVerdict({ ok: true, message: "Passed" });
//         } else {
//           setVerdict({ ok: false, message: "Failed" });
//         }
//       }, 0);
//     } else {
//       setVerdict(null);
//     }
//   }
// };


//     handlerRef.current = handleMessage;
//     window.addEventListener("message", handleMessage);

//     // small delay then send code+inputs
//     setTimeout(() => {
//       try {
//         iframe.contentWindow.postMessage({ code: transformedCode, inputs }, "*");
//       } catch (e) {
//         appendOutput("Error: could not post message to iframe\n");
//         setStatus("Execution failed");
//       }
//     }, 50);
//   };

//   // cleanup on unmount
//   useEffect(() => {
//     return () => {
//       if (iframeRef.current) {
//         try { document.body.removeChild(iframeRef.current); } catch (e) {}
//         iframeRef.current = null;
//       }
//       if (handlerRef.current) {
//         window.removeEventListener("message", handlerRef.current);
//         handlerRef.current = null;
//       }
//     };
//   }, []);

//   const clearAll = () => {
//     setOutput("");
//     setExpectedOutput("");
//     setUserInput("");
//     setVerdict(null);
//     setStatus("Ready");
//   };

//   const editorOptions = {
//     autoIndent: "full",
//     fontFamily: "JetBrains Mono, Fira Code, monospace",
//     fontSize: 14,
//     lineHeight: 22,
//     minimap: { enabled: false },
//     automaticLayout: true,
//     scrollBeyondLastLine: false,
//     padding: { top: 16, bottom: 16 },
//   };

//   if (showLoader) {
//     return (
//       <div className="codii-loader-container">
//         <img src="/codii_logo_trans.png" alt="Codii Logo" className="codii-loader-logo" />
//         <div className="codii-progress-bar"><div className="codii-progress-fill" /></div>
//         <div className="codii-loader-text">Initializing your coding space...</div>
//       </div>
//     );
//   }

//   return (
//     <div className="app-container">
//       {/* Top Bar */}
//       <div className="top-bar">
//         <div className="left-section">
//           <img src="/codii_logo_trans.png" alt="Codii Logo" className="codii-logo" />
//         </div>

//         <div className="center-section">
//           <button onClick={runJs} className="run-btn">▶ Run</button>
//         </div>

//         <div className="right-section">
//           <span className="output-label">Output</span>
//           <button onClick={clearAll} className="clear-btn">Clear</button>
//         </div>
//       </div>

//       {/* Main Layout */}
//       <div className="main-content">
//         <div className="editor-section" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
//           <div style={{ flex: 1, minHeight: 0 }}>
//             <Editor
//               height="100%"
//               language="javascript"
//               theme="vs-dark"
//               value={code}
//               onChange={(value) => setCode(value || "")}
//               options={editorOptions}
//             />
//           </div>
//         </div>

//         <div className="editor-section output-section" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
     

//           <div className="" style={{display:"flex"}}> 
//      {/* Input */}
//              <div style={{ height: "45vh",width:"50%", borderTop: "1px solid rgba(255,87,68,0.08)",borderRight:"3px solid rgba(255,87,68,0.08)", display: "flex", flexDirection: "column" }}>
//             <div style={{ padding: "8px 12px", borderBottom: "1px solid rgba(255,87,68,0.03)" }}><strong>Input</strong></div>
//             <textarea
//               placeholder="Enter input here (one line per input). Use input('prompt') or Node-style fs.readFileSync(0,'utf8')."
//               value={userInput}
//               onChange={(e) => setUserInput(e.target.value)}
//               style={{
//                 width: "100%", height: "100%", background: "#0f0f0f", color: "#e6e6e6",
//                 border: "none", padding: "12px", fontFamily: "JetBrains Mono, monospace",
//                 fontSize: "13px", resize: "none", outline: "none", overflow: "auto"
//               }}
//             />
            
//           </div>

//                       {/* Expected Output */}
//           <div style={{ height: "45vh",width:"50%", borderTop: "1px solid rgba(255,87,68,0.08)", display: "flex", flexDirection: "column" }}>
//             <div style={{ padding: "8px 12px", borderBottom: "1px solid rgba(255,87,68,0.03)" }}><strong>Expected Output (Optional)</strong></div>
//             <textarea
//               placeholder="Optional: Enter expected output to auto-verify."
//               value={expectedOutput}
//               onChange={(e) => setExpectedOutput(e.target.value)}
//               style={{
//                 width: "100%", height: "100%", background: "#0f0f0f", color: "#e6e6e6",
//                 border: "none", padding: "12px", fontFamily: "JetBrains Mono, monospace",
//                 fontSize: "13px", resize: "none", outline: "none", overflow: "auto"
//               }}
//             />
//           </div>
//           </div>
         



//           {/* Output */}
//           <div style={{ height: "50vh", borderTop: "1px solid rgba(255,87,68,0.08)", display: "flex", flexDirection: "column" }}>
//             <div style={{ padding: "8px 12px", borderBottom: "1px solid rgba(255,87,68,0.03)", display: "flex", justifyContent: "space-between" }}>
//               <strong>Output</strong>
//               {/* <span style={{ fontSize: 12, color: "#e0e0e0" }}>{status}</span> */}
//             </div>
//             <textarea
//               ref={outputRef}
//               readOnly
//               value={output}
//               style={{
//                 width: "100%", height: "100%", background: "#0b0b0b", color: "#9fffa3",
//                 border: "none", padding: "12px", fontFamily: "JetBrains Mono, monospace",
//                 fontSize: "13px", resize: "none", outline: "none", overflow: "auto", whiteSpace: "pre"
//               }}
//             />
//             {verdict && (
//               <div style={{
//                 padding: "10px 12px",
//                 color: verdict.ok ? "#00ff88" : "#ff5744",
//                 fontWeight: 700,
//                 borderTop: "1px solid rgba(255,87,68,0.03)",
//                 background: "rgba(255,255,255,0.02)"
//               }}>
//                 {verdict.message}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default JsCompiler;



import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import Editor from "@monaco-editor/react";
import { fileAPI } from '../services/api';
// keep your existing CSS (C++ page styles)
import "../App.css";

export default function JsCompiler() {
  const location = useLocation();
  const navigate = useNavigate();

  const [currentFile, setCurrentFile] = useState(location.state?.file || null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  // -------------------------------
  // Original working logic (kept)
  // -------------------------------
  const [code, setCode] = useState(`// Codeforces Problem A: Team
const fs = require('fs');
const data = fs.readFileSync(0, 'utf8').trim().split('\\n');

const n = parseInt(data[0]);
let count = 0;

for (let i = 1; i <= n; i++) {
  const nums = data[i].split(' ').map(Number);
  const sure = nums.reduce((a, b) => a + b, 0);
  if (sure >= 2) count++;
}

console.log(count);
`);
  const [userInput, setUserInput] = useState("5\n1\n4\n10\n23\n100");
  const [expectedOutput, setExpectedOutput] = useState("4");

  // Terminal messages (compilation/errors/messages)
  const [terminalOutput, setTerminalOutput] = useState("");
  const terminalRef = useRef(null);

  // program stdout buffer (synchronous) + preview state
  const programOutputRef = useRef("");
  const [programOutputState, setProgramOutputState] = useState("");

  const [status, setStatus] = useState("Ready");
  const [verdict, setVerdict] = useState(null);
  const [showLoader, setShowLoader] = useState(true);

  // iframe + handler refs
  const iframeRef = useRef(null);
  const handlerRef = useRef(null);

  // Load file content if opening a file
  useEffect(() => {
    const loadFileContent = async () => {
      if (currentFile && currentFile.id) {
        try {
          const fileData = await fileAPI.getFile(currentFile.id);
          setCode(fileData.content || '');
          setCurrentFile(fileData);
          setHasUnsavedChanges(false);
        } catch (error) {
          console.error('Error loading file:', error);
        }
      }
    };
    loadFileContent();
  }, [currentFile?.id]);

  useEffect(() => {
    const t = setTimeout(() => setShowLoader(false), 600);
    return () => clearTimeout(t);
  }, []);

  // -------------------------------
  // Utilities
  // -------------------------------
  const appendTerminal = (text) => {
    setTerminalOutput((prev) => {
      const next = prev + text;
      // scroll after DOM update
      setTimeout(() => {
        const el = terminalRef.current;
        if (el) el.scrollTop = el.scrollHeight;
      }, 0);
      return next;
    });
  };

  const escapeHtml = (s = "") =>
    String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

  const normalize = (s = "") =>
    (s ?? "")
      .replace(/\r/g, "")
      .split("\n")
      .map((line) => line.replace(/[ \t]+$/g, "")) // trim trailing spaces/tabs
      .join("\n")
      .replace(/\n+$/g, "") // remove trailing blank lines
      .trim();

  // Transform Node-style fs/readFileSync to __readStdin() and shim require('fs')
  function transformNodeStyleCode(userCode) {
    let transformed = userCode;

    transformed = transformed.replace(
      /\b(?:const|let|var)\s+([A-Za-z_$][\w$]*)\s*=\s*require\(\s*['"]fs['"]\s*\)\s*;?/g,
      (m, varName) => `const ${varName} = { readFileSync: ()=>__readStdin() };`
    );

    transformed = transformed.replace(
      /require\(\s*['"]fs['"]\s*\)\s*\.readFileSync\s*\(\s*0\s*(?:,\s*['"]utf-?8['"]\s*)?\)/g,
      "__readStdin()"
    );

    transformed = transformed.replace(
      /\b([A-Za-z_$][\w$]*)\.readFileSync\s*\(\s*0\s*(?:,\s*['"]utf-?8['"]\s*)?\)/g,
      "__readStdin()"
    );

    transformed = transformed.replace(/require\(\s*['"]fs['"]\s*\)/g, "{ readFileSync: ()=>__readStdin() }");

    return transformed;
  }

  // -------------------------------
  // Run / sandboxed iframe logic
  // -------------------------------
  const runJs = () => {
    setStatus("Running...");
    setVerdict(null);

    // reset buffers
    programOutputRef.current = "";
    setProgramOutputState("");
    setTerminalOutput("");
    appendTerminal("Execution started...\n");

    // cleanup old iframe & handler
    if (iframeRef.current) {
      try { document.body.removeChild(iframeRef.current); } catch (e) {}
      iframeRef.current = null;
    }
    if (handlerRef.current) {
      window.removeEventListener("message", handlerRef.current);
      handlerRef.current = null;
    }

    const inputs = userInput.replace(/\r/g, "").split("\n");
    const transformedCode = transformNodeStyleCode(code);

    const iframeHtml = `<!doctype html>
<html><head><meta charset="utf-8"></head><body>
<script>
(function(){
  function forward(type, text) { parent.postMessage({ type: type, data: String(text) }, "*"); }
  // console wrapper: log -> 'log', error -> 'error'
  window.console = {
    log: (...args) => forward('log', args.join(' ')),
    error: (...args) => forward('error', args.join(' ')),
    warn: (...args) => forward('log', args.join(' '))
  };

  var __inputs = [];
  var __idx = 0;
  function __readStdin(){ return __inputs.join('\\n'); }
  function input(promptText){
    var hasPrompt = (typeof promptText === 'string' && promptText.length>0);
    if(hasPrompt) console.log(promptText);
    var val = (__idx < __inputs.length) ? __inputs[__idx++] : undefined;
    if(hasPrompt) console.log((val===undefined) ? "[No Input Provided]" : String(val));
    if(val===undefined) throw new Error('No more input provided!');
    return val;
  }
  var process = { stdin: { on: function(evt, cb){ try{ if(evt==='data') cb(__readStdin()); if(evt==='end') cb(); } catch(e){} }, setEncoding:function(){} } };

  window.__readStdin = __readStdin;
  window.input = input;
  window.process = process;

  window.addEventListener('message', function(ev){
    try {
      var payload = ev.data || {};
      if (!payload.code) return;
      __inputs = Array.isArray(payload.inputs) ? payload.inputs.slice() : [];
      __idx = 0;
      try {
        (function(){ eval(payload.code); })();
      } catch (execErr) {
        console.error(execErr && execErr.message ? execErr.message : String(execErr));
      } finally {
        parent.postMessage({ type: 'done' }, "*");
      }
    } catch (outer) {
      console.error(outer && outer.message ? outer.message : String(outer));
      parent.postMessage({ type: 'done' }, "*");
    }
  });
})();
<\/script>
</body></html>`;

    const iframe = document.createElement("iframe");
    iframe.sandbox = "allow-scripts";
    // keep iframe hidden (preview handled by the preview-frame element)
    iframe.style.display = "none";
    iframe.srcdoc = iframeHtml;
    document.body.appendChild(iframe);
    iframeRef.current = iframe;

    // handler: logs -> preview, errors -> terminal, done -> compare using programOutputRef
    const handleMessage = (event) => {
      const d = event.data || {};
      if (d.type === "log") {
        // program stdout -> preview (only)
        programOutputRef.current = programOutputRef.current + d.data + "\n";
        setProgramOutputState(programOutputRef.current);

        // update preview iframe srcdoc (preview-frame)
        const previewFrame = document.getElementById("preview-frame");
        if (previewFrame) {
          const safe = `<meta charset="utf-8"><style>body{background:#0f0f0f;color:#dcdcdc;font-family:monospace;padding:12px;white-space:pre-wrap}</style><pre>${escapeHtml(programOutputRef.current)}</pre>`;
          if (previewFrame.srcdoc !== safe) previewFrame.srcdoc = safe;
        }
      } else if (d.type === "error") {
        // runtime error -> terminal only
        appendTerminal("Error: " + d.data + "\n");
      } else if (d.type === "done") {
        setStatus("Execution finished");
        appendTerminal("=== Program finished ===\n");

        if (expectedOutput && expectedOutput.trim().length > 0) {
          const actual = normalize(programOutputRef.current);
          const expected = normalize(expectedOutput);

          if (actual === expected) {
            setVerdict({ ok: true, message: "Passed" });
            appendTerminal("=== Verdict: Passed ===\n");
          } else {
            setVerdict({ ok: false, message: "Failed" });
            appendTerminal("=== Verdict: Failed ===\n");
            appendTerminal("--- Expected (normalized) ---\n" + (expected || "(empty)") + "\n");
            appendTerminal("--- Actual (normalized) ---\n" + (actual || "(empty)") + "\n");
          }
        } else {
          setVerdict(null);
        }
      }
    };

    handlerRef.current = handleMessage;
    window.addEventListener("message", handleMessage);

    // small delay then send code+inputs
    setTimeout(() => {
      try {
        appendTerminal("Posting code to iframe...\n");
        iframe.contentWindow.postMessage({ code: transformedCode, inputs }, "*");
      } catch (e) {
        appendTerminal("Error: could not post message to iframe\n");
        setStatus("Execution failed");
      }
    }, 50);
  };

  // cleanup on unmount
  useEffect(() => {
    return () => {
      if (iframeRef.current) {
        try { document.body.removeChild(iframeRef.current); } catch (e) {}
        iframeRef.current = null;
      }
      if (handlerRef.current) {
        window.removeEventListener("message", handlerRef.current);
        handlerRef.current = null;
      }
    };
  }, []);

  const handleCodeChange = (value) => {
    setCode(value || '');
    if (currentFile) {
      setHasUnsavedChanges(true);
    }
  };

  const saveFile = async () => {
    if (!currentFile || !currentFile.id) {
      alert('No file is currently open');
      return;
    }

    try {
      await fileAPI.updateFile(currentFile.id, code);
      setHasUnsavedChanges(false);
      appendTerminal(`File saved: ${currentFile.name}\n`);
    } catch (error) {
      console.error('Error saving file:', error);
      alert('Failed to save file');
    }
  };

  const goToDashboard = () => {
    if (hasUnsavedChanges) {
      const confirmLeave = window.confirm('You have unsaved changes. Do you want to leave without saving?');
      if (!confirmLeave) return;
    }
    navigate('/dashboard');
  };

  // clear helpers
  const clearInput = () => setUserInput("");
  const clearExpected = () => setExpectedOutput("");
  const clearAll = () => {
    setUserInput("");
    setExpectedOutput("");
    programOutputRef.current = "";
    setProgramOutputState("");
    const f = document.getElementById("preview-frame");
    if (f) f.srcdoc = "";
    setTerminalOutput("");
    setVerdict(null);
    setStatus("Ready");
  };

  // editor options
  const editorOptions = {
    minimap: { enabled: false },
    automaticLayout: true,
    fontFamily: "JetBrains Mono, Fira Code, monospace",
    fontSize: 13,
    lineHeight: 20,
    padding: { top: 12, bottom: 12 },
  };

  // -------------------------------
  // Render: same DOM structure + IDs/classes as C++ page
  // -------------------------------
  if (showLoader) {
    return (
      <div className="codii-loader-container">
        <img src="https://raw.githubusercontent.com/1lakshy/1lakshy/main/codii_logo_trans.png" alt="Codii Logo" className="codii-loader-logo" />
        <div className="codii-progress-bar"><div className="codii-progress-fill" /></div>
        <div className="codii-loader-text">Initializing your coding space...</div>
      </div>
    );
  }

  return (
    <div id="app-root" style={{ height: "100vh" }}>
      <div id="main">
        <div id="topbar">
          <div id="title">
            <img
              id="logo"
              src="https://raw.githubusercontent.com/1lakshy/1lakshy/main/codii_logo_trans.png"
              alt="logo"
              onClick={goToDashboard}
              style={{ cursor: 'pointer' }}
              title="Back to Dashboard"
            />
            {currentFile && (
              <span style={{ marginLeft: '10px', fontSize: '14px', color: '#888' }}>
                {currentFile.name} {hasUnsavedChanges && '*'}
              </span>
            )}
          </div>
          <div id="actions">
            {currentFile && (
              <button
                onClick={saveFile}
                style={{
                  marginRight: '8px',
                  background: hasUnsavedChanges ? '#00d084' : '#555',
                }}
              >
                {hasUnsavedChanges ? 'Save *' : 'Save'}
              </button>
            )}
            <button id="compile" onClick={runJs}>Compile</button>
          </div>
        </div>

        <div id="main-grid">
          <div id="col-editor" className="col">
            <div className="panel-header">Editor</div>
            <div id="editor" className="panel-body" style={{ minHeight: 0 }}>
              <Editor
                height="100%"
                language="javascript"
                theme="vs-dark"
                value={code}
                onChange={handleCodeChange}
                options={editorOptions}
              />
            </div>
          </div>

          <div id="col-center" className="col">
            <div id="center-top" className="half">
              <div className="panel-header">
                Program Input <small>(saved as input.txt)</small>
                <div className="header-controls">
                  <button id="clear-input" title="Clear input" onClick={clearInput}>Clear</button>
                </div>
              </div>
              <textarea id="stdin-input" className="panel-body textarea" value={userInput} onChange={(e) => setUserInput(e.target.value)} />
            </div>

            <div id="center-bottom" className="half">
              <div className="panel-header">
                Preview
                <div className="header-controls">
                  <div id="validation-status" style={{ display: 'none' }}>
                    <div id="validation-result" className="validation-result"></div>
                  </div>
                </div>
              </div>
              <div id="preview-area" className="panel-body" style={{ padding: 0 }}>
                <iframe id="preview-frame" title="preview" style={{ width: "100%", height: "100%", border: 0 }} />
              </div>
            </div>
          </div>

          <div id="col-expected" className="col">
            <div id="expected-top" className="half">
              <div className="panel-header">
                Expected Output
                <div className="header-controls">
                  <button id="clear-expected" title="Clear expected output" onClick={clearExpected}>Clear</button>
                </div>
              </div>
              <textarea id="expected-output" className="panel-body textarea" value={expectedOutput} onChange={(e) => setExpectedOutput(e.target.value)} />
            </div>

            <div id="expected-bottom" className="half">
              <div className="panel-header">Terminal Output</div>
              <div id="terminal-attach" className="panel-body terminal-attach" style={{ padding: 0 }}>
                <textarea
                  ref={terminalRef}
                  readOnly
                  value={terminalOutput}
                  style={{
                    width: "100%",
                    height: "100%",
                    resize: "none",
                    background: "#070707",
                    color: "#e6e6e6",
                    border: "none",
                    padding: 8,
                    fontFamily: "JetBrains Mono, monospace",
                    fontSize: 13,
                    outline: "none",
                    whiteSpace: "pre"
                  }}
                />
              </div>
              <div
  id="status"
  className="status"
  style={verdict ? { background: verdict.ok ? "green" : "red" } : {}}
>
  {verdict ? verdict.message : status}
</div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
